import { render } from "./AtratioTrend.vue?vue&type=template&id=038947f6&scoped=true"
import script from "./AtratioTrend.vue?vue&type=script&lang=js"
export * from "./AtratioTrend.vue?vue&type=script&lang=js"

import "./AtratioTrend.vue?vue&type=style&index=0&id=038947f6&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038947f6"]])

export default __exports__